// extracted by mini-css-extract-plugin
export var container = "SetList-module--container--3cc31";
export var set = "SetList-module--set--31e2b";
export var sets = "SetList-module--sets--65c62";
export var symbol = "SetList-module--symbol--9cb83";